import React, { Component } from 'react';
import styled from 'styled-components';

const ToggleElementWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	margin-top: -32px;
`;

const TogglePanelCont = styled.div`
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	color: #fff;
	background-color: #9a9ca0;
	border-radius: 100%;
	font-size: 1.2em;
	right: 0;
	float: right;
	margin-right: -5px;
`;

const TogglePanelTitleBody = styled.div`
	background: #f5f5f5;
	transition: all .35s ease;
  padding: 20px;
  width: calc(100% - 40px);
	color: #575757;
	border-radius: 1.5em;
	overflow: hidden;
	position: relative;
	// margin-right: 21px;
	margin-top: ${props => props.isOpen ? '20px' : '0px'};
	padding-top: ${props => props.isOpen ? '20px' : '0px'};
	padding-bottom: ${props => props.isOpen ? '20px' : '0px'};
	height: ${props => props.isOpen ? 'auto' : '0'};
`;

class TogglePanel extends Component {

	state = { isOpen: false };

	handleToggle = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	render() {
		return(
			<ToggleElementWrapper>
				<TogglePanelCont className='togglePanelCont' onMouseDown={this.handleToggle} >i</TogglePanelCont>
				<TogglePanelTitleBody isOpen={this.state.isOpen} >
					{this.props.children}
				</TogglePanelTitleBody>
			</ToggleElementWrapper>
		);
	}
}

export default TogglePanel;



// WEBPACK FOOTER //
// ./src/html/controls/TogglePanel.js